export default __webpack_public_path__ + "static/media/6ixer01.944012a6.jpg";